import { MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
//import { MDBBadge, MDBBtn, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import { useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import api from '../../app/api/agent'
import { GlobalStateContext } from '../../store/GlobalState';
import CustomNavBar from '../../components/CustomNavBar';
//import Cookies from 'js-cookie';
import React from 'react';
import formatDate from '../../utils/formatDate';

function AlertList() {

    const [pageRecord, setPageRecord] = useState<Array<{ [x: string]: any }>[] | undefined>(undefined)
    const [recordList, setRecord] = useState<Array<{ [x: string]: any }>| undefined>(undefined)
    const [pageNum, setPageNum] = useState(1)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [pageSize, setPageSize] = useState(10)
    const [TotalRecord, setTotalRecord] = useState(0)

    const globalState = useContext(GlobalStateContext);
    useEffect(()=>{

        if(localStorage.accessToken){
            api.get(`/Account/userInfo`).then((response)=>{
                    if (response.status !== 200){
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")
                        globalState?.setAccessToken('');
                        window.location.href='/'
                    }else{
                      /* if(response.data.role.toString() !== "0"){
                          window.location.href='/'
                      } */
                    }
                    }).catch(()=>{
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")

                        globalState?.setAccessToken('');
                        window.location.href='/'
                    })
        }else{
          api.get("/OIDC/getUserInfo",{withCredentials: true,}).then((response)=>{
                              if (response.status !== 200){
                                      window.location.href='/'
                              }else{
                                /* if(response.data.role.toString() !== "0"){
                                    window.location.href='/'
                                } */
                              }
                              }).catch(()=>{
                                  window.location.href='/'
                          })
        }
        if(localStorage.getItem("role") === "0"){
          getRecord()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(()=>{
        setPageNum(pageNum)
    },[pageNum])


    const getRecord=async ()=>{
      if(localStorage.accessToken){
        await api.get(`/Alert`).then((response)=>{
            if(response.data.length === 0){
                setTotalRecord(0);
            }else{
                setRecord(response.data)
                pageSeperate(response.data)
                setTotalRecord(response.data.length)
            }
        })
      }else{

        await api.get(`/Alert`,{withCredentials: true,}).then((response)=>{
            if(response.data.length === 0){
                setTotalRecord(0);
            }else{
                setRecord(response.data)
                pageSeperate(response.data)
                setTotalRecord(response.data.length)
            }
        })
      }
    }
    const pageSeperate = (records: Array<{ [x: string]: any }>) =>{
        var i = 0;
        var tempList: Array<{ [x: string]: any }>[] = []
        records?.forEach((record, index)=>{
            if(tempList[i] === undefined){tempList[i]=[]}
            tempList[i].push(record)
            if((index+1)%10 ===0){i+=1}
        })
        setPageRecord(tempList)
    }

    useEffect(()=>{
        //getRecord();
        if(pageRecord != null)
       setRecord(pageRecord[pageNum - 1])
    },[pageNum, pageRecord])



    const handleClickOpenWindow = (id: string) => {
      window.location.href=`/alert/edit?alertId=${id}`
    };


  return (
    <Container className="table-responsive" style={{minWidth: "770px",padding: 0, fontFamily:"Poppins", width:"95%", height:"100vh", background:"linear-gradient(45deg,rgba(255, 255, 255, 1) 0%, rgba(245, 255, 247, 1) 50%, rgba(222, 255, 232, 1) 100%)"}}>
    <CustomNavBar></CustomNavBar>
    
    
    {localStorage.getItem("role") !== "0" && 
          <><div>404 not found</div></>
    }

    
    {localStorage.getItem("role") === "0" && 
          <>
        
    {/* <Table striped bordered hover responsive size='sm'> */}
    <MDBTable align='middle' className="table table-hover" style={{width:"95%", margin:"auto"}}>
      {/* <thead style={{borderBottom:"12px"}}> */}
      <MDBTableHead>
        <tr className='table-success'>
          <th>Id</th>
          <th>Display Name</th>
          <th>Last Send Time</th>
          <th>Edit</th>
        </tr>
      {/* </thead> */}
      </MDBTableHead>
      <MDBTableBody>
      {/* <tbody> */}
      {recordList === undefined || recordList === null ? <></>: recordList.map((record, recordIndex)=>{
            return<React.Fragment key={record["id"]}>
                <tr>
                <td>{record["id"].toString()}</td>
                <td>{record["displayName"].toString()}</td>
                <td>{formatDate.formattedDate(new Date(record["lastSendTime"].toString()))}</td>
                <td>
                <span onClick={()=>{handleClickOpenWindow(record["id"])}} style={{cursor:"pointer", color:"blue", fontSize:"15px"}}>
                    <u>Edit</u>
                </span>
                </td>
                </tr></React.Fragment>
      })}
      
      </MDBTableBody>
    </MDBTable>
    {/* </Table> */}
    <div style={{marginTop:"20px", textAlign:"right", width:"90%", display:"flex", flexDirection:"row", justifyContent:"right"}}>
        <div style={{marginRight:"30px"}}>
            {/* <span style={{fontSize:"20px", verticalAlign:"middle"}}>{pageNum+1}-{pageRecord? (pageRecord[pageNum] ? pageRecord[pageNum].length : 0) : recordList?.length} OF {recordList?.length}</span> */}
            <span style={{fontSize:"20px", verticalAlign:"middle"}}>{TotalRecord === 0? 0 : 1 + (pageNum -1)* pageSize}-{(TotalRecord/pageSize > pageNum)? (pageNum) * pageSize: TotalRecord} OF {TotalRecord}</span>
        </div>
        <button onClick={(e)=>{(1 < pageNum)? setPageNum(pageNum-1): setPageNum(pageNum)}} style={{width:"30px", height:"inherit", cursor:"pointer"}}>&lt;</button>
        <button onClick={(e)=>{(TotalRecord/pageSize > pageNum)? setPageNum(pageNum+1): setPageNum(pageNum)}} style={{width:"30px", marginRight:"10px", height:"inherit", cursor:"pointer"}}>&gt;</button>    
    </div>
       
    </>
    }

    
      <div className='bar-styles'>
        Steel Bar Form System &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Version: {process.env.REACT_APP_VERSION}
        <div style={{float:'right', marginRight: '40px'}}>
        </div>
      </div>
    </Container>
  );
}

export default AlertList;